import React, { useState } from 'react';
import { supabase } from './supabaseClient';

const AuthPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) alert(error.message);
    setLoading(false);
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.signUp({ email, password });
    if (error) alert(error.message);
    else alert("נרשמת בהצלחה!");
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #fef3c7 0%, #fce7f3 100%)",
      padding: "20px",
      fontFamily: "system-ui, -apple-system, sans-serif",
      direction: "rtl"
    }}>
      <div style={{
        background: "rgba(255, 255, 255, 0.95)",
        padding: "40px 30px",
        borderRadius: "30px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth: "400px",
        textAlign: "center",
        border: "4px solid #fff"
      }}>
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
  <img 
    src="/landing-logo.jpeg" 
    alt="לוגו יש לי גלידה הכי טובה" 
    style={{ 
      maxWidth: '220px', 
      height: 'auto',
      display: 'block',
      margin: '0 auto'
    }} 
  />
</div>
        
        
        
        <p style={{ color: "#666", marginBottom: "30px", fontSize: "16px" }}>
          מחשבון נינג'ה קרימי חכם ✨
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <input
  type="email"
  placeholder="אימייל"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  style={{
    width: '100%',
    maxWidth: '400px',
    margin: '0 auto',
    padding: '14px',
    borderRadius: '15px',
    border: '2px solid #eee',
    outline: 'none',
    fontSize: '16px',
    textAlign: 'right',
    boxSizing: 'border-box'
  }}
/>
          

          <div style={{ position: 'relative', width: '100%', maxWidth: '400px', margin: '0 auto' }}>
  <input
    type={showPassword ? "text" : "password"}
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    placeholder="סיסמה"
    style={{
      width: '100%',
      padding: '14px',
      paddingLeft: '45px', // מרווח לעין
      paddingRight: '15px',
      borderRadius: '15px',
      border: '2px solid #eee',
      outline: 'none',
      fontSize: '16px',
      textAlign: 'right',
      direction: 'rtl',
      boxSizing: 'border-box' // שומר שהשדה לא יברח מהצדדים
    }}
  />
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: 'absolute',
      left: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    {showPassword ? "👁️" : "👁️‍🗨️"} 
  </button>
</div>
<p style={{ fontSize: '12px', color: '#ff4d4d', marginTop: '5px', textAlign: 'right', direction: 'rtl' }}>
  * הסיסמה חייבת להכיל לפחות 8 תווים, אות גדולה, אות קטנה וסימן מיוחד.
</p>
{!isSignUp && (
  <button onClick={() => setIsSignUp(true)} style={{ background: "linear-gradient(to right, #EC4899, #7C3AED)", color: "white", padding: "14px", borderRadius: "15px", border: "none", fontSize: "16px", fontWeight: "bold", cursor: "pointer", marginBottom: "8px" }}>
    משתמשת חדשה? צרי חשבון כאן ✨
  </button>
)}
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              background: "linear-gradient(to right, #7C3AED, #EC4899)",
              color: "white",
              padding: "16px",
              borderRadius: "15px",
              border: "none",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              marginTop: "10px",
              boxShadow: "0 10px 20px rgba(124, 58, 237, 0.2)"
            }}
          >
            {loading ? "רק רגע..." : "כניסה למטבח 🍦"}
          </button>
        </div>

        {/* תיבת ערך פרימיום */}
        <div style={{ 
          marginTop: "20px", 
          padding: "15px", 
          background: "rgba(124, 58, 237, 0.05)", 
          borderRadius: "15px",
          border: "1px dashed #7C3AED",
          textAlign: "right"
        }}>
          <p style={{ 
            fontSize: "14px", 
            color: "#7C3AED", 
            fontWeight: "bold", 
            marginBottom: "10px",
            textAlign: "center" 
          }}>
            🎁 3 ימי ניסיון חינם לכל האפליקציה
          </p>
          
          <ul style={{ 
            fontSize: "12px", 
            color: "#555", 
            margin: "0", 
            padding: "0 15px 0 0", 
            listStyleType: "none",
            lineHeight: "1.6"
          }}>
            <li>✅ גישה מלאה למחשבון הנינג'ה</li>
            <li>✅ צפייה בכל מתכוני הקהילה</li>
            <li>✅ שמירת מתכונים אישיים בענן</li>
            <li>✅ שיתוף מתכונים עם אחרים</li>
          </ul>

          <p style={{ 
            fontSize: "11px", 
            color: "#888", 
            marginTop: "10px", 
            textAlign: "center" 
          }}>
           לאחר מכן רק **₪6.90** לחודש או **₪69.90** למנוי שנתי
          </p>
        </div>

  {isSignUp && (
  <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 10 }}>
    <p style={{ color: "#7C3AED", fontWeight: 700, fontSize: 15 }}>מלאי מייל וסיסמה למעלה ולחצי:</p>
    <button onClick={async (e) => {
      if (!email.trim() || !password.trim()) return alert("אנא מלאי מייל וסיסמה לפני ההרשמה 😊");
      await handleSignUp(e);
    }} disabled={loading} style={{ background: "linear-gradient(to right, #7C3AED, #EC4899)", color: "white", padding: "14px", borderRadius: "15px", border: "none", fontSize: "16px", fontWeight: "bold", cursor: "pointer" }}>
      {loading ? "רק רגע..." : "צרי חשבון ✨"}
    </button>
    <button onClick={() => setIsSignUp(false)} style={{ background: "none", border: "none", color: "#888", fontSize: "13px", cursor: "pointer", textDecoration: "underline" }}>
      כבר יש לי חשבון, חזרה לכניסה
    </button>
  </div>
)}
      </div>
    </div>
  );
};

export default AuthPage;